var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SliceDivider } from './slice-divider';
import { WARM_GREY } from '../constants';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { ContentNode } from './content-node';
import { sliceColorInfo } from '../utils/slice-color-info';
var cls = classNames('slice-value-tout');
export var SliceValueToutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: ", "em;\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n    text-align: center;\n    \n    ", "\n  "], ["\n    font-weight: 300;\n    font-size: ", "em;\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n    text-align: center;\n    \n    ", "\n  "])), 30 / 15, theme.UNIT(2), function (_a) {
    var _backgroundColor = _a._backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), _backgroundColor);
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 40 / 15),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 48 / 15)
});
var DividerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Divider: styled(SliceDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DividerStyles)
};
export var SliceValueTout = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var content = entity.content;
  var colorInfo = sliceColorInfo(entity);
  var backgroundColor = colorInfo.backgroundColor || WARM_GREY;
  return React.createElement(React.Fragment, null, React.createElement(My.Divider, {
    entity: entity
  }), React.createElement(My.Container, {
    _backgroundColor: backgroundColor,
    className: cls.name(className)
  }, React.createElement(My.Content, {
    entity: content
  })), React.createElement(My.Divider, {
    entity: entity
  }));
};
SliceValueTout.defaultProps = SliceValueToutDefaultProps;
SliceValueTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;